import React from 'react';

function ProjectTabs({ activeTab, tabs, onTabClick }) {
    return (
        <div className="project_tabs">
            {tabs.map(tab => {
                return <div
                    key={tab.key}
                    className={`project_tabs_tab ${activeTab === tab.key && 'active'}`}
                    onClick={() => onTabClick(tab.key)}>
                    {tab.name}
                </div>;
            })}
        </div>
    );
}


export default ProjectTabs;